module.exports = __webpack_public_path__ + "static/media/user.e5defcd6.svg";